export const DEFAULT_LOCALE = 'en-US';

export const privacyPath = (lang) => (lang === 'ua' ? '/privacy' : '/en/privacy');
export const isUaPrivacyPath = (pathname) => /^\/privacy\/?$/.test(pathname);
